module.exports = __webpack_public_path__ + "img/nubo-logo-white.02fd1de3.svg";